import { defineStore } from "pinia"
import { SystemNotificationCardData } from "src/util/types/notifications"

export interface NotificationsStoreType {
  count: number // Number of total unread notifications
  sysNotifications: SystemNotificationCardData[] // List of system notifications
}

export const useNotificationsStore = defineStore("pinia-notificationsStore", {
  persist: true,

  state: (): NotificationsStoreType => {
    return {
      count: 0,
      sysNotifications: [],
    }
  },
})
